import { forwardRef } from 'react';

import {
  MOVIE_DETAILS_ROUTE,
  TMDB_IMAGE_URL,
  DEFAULT_IMAGE_URL,
} from '../../../utils/constants';
import { MovieCardType } from '../../../types';
import { Link } from 'react-router-dom';

const MovieCard = forwardRef<HTMLLIElement, MovieCardType>(
  ({ id, title, posterPath, overview, voteAverage, voteCount }, ref) => {
    return (
      <li ref={ref} className='list-none'>
        <div className='h-[680px] bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 hover:shadow-xl transition-shadow duration-300 ease-in-out'>
          <img
            className='rounded-t-lg h-[478px] object-fill w-full'
            src={posterPath ? TMDB_IMAGE_URL + posterPath : DEFAULT_IMAGE_URL}
            alt={title}
          />
          <div className='p-5 flex flex-col justify-between h-[202px]'>
            <div>
              <p className='mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white line-clamp-1'>
                {title}
              </p>
              <p className='mb-3 font-normal text-gray-700 dark:text-gray-400 line-clamp-3'>
                {overview || title}
              </p>
            </div>
            <div className='flex justify-between'>
              <Link
                to={MOVIE_DETAILS_ROUTE + id}
                aria-label={title}
                className='inline-flex items-center px-2 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'>
                Overview
                <svg
                  className='rtl:rotate-180 w-3.5 h-3.5 ms-2'
                  aria-hidden='true'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 14 10'>
                  <path
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M1 5h12m0 0L9 1m4 4L9 9'
                  />
                </svg>
              </Link>
              {!!voteAverage && (
                <div className='flex items-center'>
                  <svg
                    className='w-4 h-4 text-yellow-500 dark:text-yellow-300 me-1'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='currentColor'
                    viewBox='0 0 22 20'>
                    <path d='M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z' />
                  </svg>
                  <p className='ms-2 text-xs font-bold text-gray-900 dark:text-white'>
                    {Math.round(voteAverage * 10) + '%'}
                  </p>
                  <span className='w-1 h-1 mx-1.5 bg-gray-500 rounded-full dark:bg-gray-400'></span>
                  <span className='text-xs font-bold text-gray-900 dark:text-white'>
                    {voteCount} reviews
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </li>
    );
  }
);

export default MovieCard;
